import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import {
  NumberItemElement,
  InsuranceButtonElement,
  InsurancePricesElement,
  OrdersStatisticsElement,
  PricesCalculatorElement,
  SuperAdminNumberItemElement,
} from "./components";
import {
  WalletIcon,
  ProfitsIcon,
  DiscountIcon,
  DebtIcon,
  TravelInsuranceButtonIcon,
  HealthInsuranceButtonIcon,
  DaskInsuranceButtonIcon,
  KaskoInsuranceButtonIcon,
  TrafficInsuranceButtonIcon,
  SuperAdminDashboardItemProfitsIcon,
  SuperAdminDashboardItemInsurancesCountIcon,
  SuperAdminDashboardItemInsurancesTotalIcon,
  SuperAdminDashboardItemAgenciesCountIcon,
  SuperAdminDashboardItemDebtIcon,
  SuperAdminDashboardItemTotalPaymentsIcon,
  SuperAdminDashboardItemTotalIncome,
  SuperAdminDashboardItemTotalIncomeIcon,
  SuperAdminDashboardItemBalanceRequestsIcon,
  SuperAdminDashboardItemPendingRequestsIcon,
  SuperAdminDashboardItemUsersIcon,
  TourismInsuranceButtonIcon,
} from "../../libs/SVGIcons";
import {
  setLoading,
  showMessage,
  handleAppError,
  clearFormErrors,
  setCurrentRecord,
} from "../../actions";
import {
  DaskInsuranceType,
  HealthInsuranceType,
  InsightDurationDaily,
  KaskoInsuranceType,
  TourismInsuranceType,
  TrafficInsuranceType,
  TravelInsuranceType,
} from "../../libs";
import axios from "../../axios";
import AppConfig from "../../constants/AppConfig";
import { ProfitsChartElement } from "./components/ProfitsChartElement";
import { Icon } from "@iconify/react/dist/iconify.js";
import { ITQModalV2 } from "../../libs/ITQModalV2";
import InsuranceRatioForm from "./components/InsuranceRatioForm";
import moment from "moment";

class Home extends Component {
  state = {
    dashboardThirdSectionHeight: 200,
    insightDurationInsurancesCount: InsightDurationDaily,
    insightInsurancesCount: null,
    insightDurationInsurancesTotal: InsightDurationDaily,
    insightInsurancesTotal: null,
    insightDurationInsurancesDiscountedTotal: InsightDurationDaily,
    insightInsurancesDiscountedTotal: null,
    insightDurationAgenciesCount: InsightDurationDaily,
    insightAgenciesCount: null,
    insightDurationTotalBalanceRequests: InsightDurationDaily,
    insightTotalBalanceRequests: null,
    insightDurationUsersCount: InsightDurationDaily,
    insightDurationProfit: InsightDurationDaily,
    insightUsersCount: null,
    insightTotalDebt: null,
    insightPendingBalanceRequests: null,
    insightPendingInsuranceRequests: null,
    insightBest5Agencies: null,
    periodicProfits: null,
    periodicProfitsSeries: null,
    periodicProfitsActiveChoice: InsightDurationDaily,
    periodicDataType: "profits",
    avgRatios: 0,
    avgPrices: 0,
  };
  dashboardFirstSection = React.createRef(null);
  dashboardSecondSection = React.createRef(null);
  dashboardThirdSection = React.createRef(null);
  componentDidMount() {
    this.props.setLoading(false);
    if (
      !this.props.user.is_super_admin &&
      !this.props.user.can_see_super_admin_dashboard
    ) {
      const home = this;
      setTimeout(function () {
        home.calculateThirdSectionHeight();
        window.addEventListener("resize", () => {
          home.calculateThirdSectionHeight();
        });
      }, 100);
      console.log("superadming 1");
    } else {
      this.getSuperAdminInsights().then(async () => {
        this.getPeriodicProfitsData();

        const res = await this.fetchAvgRatio({
          type: HealthInsuranceType,
          insurancecompanies: [0],
          fromdate: moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
          todate: moment().endOf("day").format("YYYY-MM-DD HH:mm:ss"),
        });

        console.log("superadming 2");

        console.log({ res });

        if (res && res.status === 200 && res.data) {
          const data = res.data;
          this.setState({
            avgRatios: data.avg_ratio,
            avgPrices: data.avg_price,
          });
        }
      });
    }
  }
  calculateThirdSectionHeight() {
    console.log("calculating height:");
    if (window.innerWidth <= 1700) {
      this.setState({
        dashboardThirdSectionHeight:
          window.innerHeight -
          (this.dashboardSecondSection.current.getBoundingClientRect().y +
            this.dashboardSecondSection.current.getBoundingClientRect().height +
            16) *
            0.55,
      });
    } else {
      this.setState({
        dashboardThirdSectionHeight:
          window.innerHeight -
          (this.dashboardSecondSection.current.getBoundingClientRect().y +
            this.dashboardSecondSection.current.getBoundingClientRect().height +
            16),
      });
    }
  }
  getDashbord() {
    const {
      agency_balance,
      lang,
      agency_credit,
      agency_percentage,
      agency_profit,
      is_debt_ok,
      permissions,
    } = this.props.user;
    const { user } = this.props;
    const { history, setLoading, handleAppError, setCurrentRecord } =
      this.props;
    return (
      <>
        <div className="row dashboard-section" ref={this.dashboardFirstSection}>
          <div className="col-11 col-md-12 px-0">
            {/* <h2
              style={{ fontSize: "1.25rem", marginBottom: "30px" }}
              className="inter inter-bold"
            >
              {window.sys_app_translate("Your Account", lang)}
            </h2> */}
            <div className="row dashboard-section-inner-row">
              {permissions["dashboard"]["balance"] && (
                <NumberItemElement
                  icon={<WalletIcon />}
                  numberItemTitle={window.sys_app_translate("Balance", lang)}
                  number={agency_balance}
                  currencySymbol="TL"
                  onClick={() => {
                    history.push("/app/balance-requests/view-all");
                  }}
                  lang={lang}
                />
              )}
              {permissions["dashboard"]["profit"] && (
                <NumberItemElement
                  icon={<ProfitsIcon />}
                  numberItemTitle={window.sys_app_translate("Profits", lang)}
                  number={agency_profit}
                  currencySymbol="TL"
                  lang={lang}
                />
              )}
              {permissions["dashboard"]["credit"] && (
                <NumberItemElement
                  icon={<DebtIcon />}
                  numberItemTitle="Debt"
                  number={agency_credit}
                  currencySymbol="TL"
                  lang={lang}
                />
              )}
              {permissions["dashboard"]["ratio"] && (
                <NumberItemElement
                  lang={lang}
                  icon={<DiscountIcon />}
                  numberItemTitle={window.sys_app_translate("Discount", lang)}
                  number={agency_percentage}
                  currencySymbol="TL"
                  isPercentage={true}
                  onClick={() => {
                    history.push("/app/reports/agency-ratios");
                  }}
                />
              )}
            </div>
          </div>
        </div>
        <div
          className="row dashboard-section"
          ref={this.dashboardSecondSection}
          style={{ marginTop: "1rem" }}
        >
          <div className="col-11 col-md-12 px-0">
            {/* <h2
              style={{ fontSize: "1.25rem", marginBottom: "30px" }}
              className="inter inter-bold"
            >
              Insurances
            </h2> */}
            <div className="row dashboard-section-inner-row">
              <InsuranceButtonElement
                insuranceButtonIcon={<HealthInsuranceButtonIcon />}
                onClick={() => {
                  history.push("/app/insurance-requests/create");
                }}
                insuranceButtonTitle={window.sys_app_translate(
                  "Health Insurance",
                  lang
                )}
                secondaryButtonTitle={
                  window.sys_app_translate("Approved Today") +
                  ": " +
                  (typeof user.agency_approved_health === "undefined"
                    ? "-"
                    : user.agency_approved_health)
                }
                showGlowingDot={user.agency_approved_health > 0}
              />
              <InsuranceButtonElement
                insuranceButtonIcon={<TravelInsuranceButtonIcon />}
                insuranceButtonTitle={window.sys_app_translate(
                  "Travel Insurance",
                  lang
                )}
                secondaryButtonTitle={
                  window.sys_app_translate("Approved Today") +
                  ": " +
                  (typeof user.agency_approved_travel === "undefined"
                    ? "-"
                    : user.agency_approved_travel)
                }
                onClick={() => {
                  setCurrentRecord(TravelInsuranceType);
                  history.push("/app/insurance-requests/create");
                }}
              />
              <InsuranceButtonElement
                insuranceButtonIcon={<DaskInsuranceButtonIcon />}
                insuranceButtonTitle={window.sys_app_translate(
                  "DASK Insurance",
                  lang
                )}
                secondaryButtonTitle={
                  window.sys_app_translate("Waiting Pricing") +
                  ": " +
                  (typeof user.agency_waitingpricing_dask === "undefined"
                    ? "-"
                    : user.agency_waitingpricing_dask)
                }
                secondaryButtonTitle2={
                  window.sys_app_translate("Price is set") +
                  ": " +
                  (typeof user.agency_priceset_dask === "undefined"
                    ? "-"
                    : user.agency_priceset_dask)
                }
                showGlowingDot2={user.agency_priceset_dask > 0}
                onClick={() => {
                  setCurrentRecord(DaskInsuranceType);
                  history.push("/app/insurance-requests/create");
                }}
              />
              <InsuranceButtonElement
                insuranceButtonIcon={<TrafficInsuranceButtonIcon />}
                insuranceButtonTitle={window.sys_app_translate(
                  "Traffic Insurance",
                  lang
                )}
                secondaryButtonTitle={
                  window.sys_app_translate("Waiting Pricing") +
                  ": " +
                  (typeof user.agency_waitingpricing_traffic === "undefined"
                    ? "-"
                    : user.agency_waitingpricing_traffic)
                }
                secondaryButtonTitle2={
                  window.sys_app_translate("Price is set") +
                  ": " +
                  (typeof user.agency_priceset_traffic === "undefined"
                    ? "-"
                    : user.agency_priceset_traffic)
                }
                showGlowingDot2={user.agency_priceset_traffic > 0}
                onClick={() => {
                  setCurrentRecord(TrafficInsuranceType);
                  history.push("/app/insurance-requests/create");
                }}
              />
              <InsuranceButtonElement
                insuranceButtonIcon={<KaskoInsuranceButtonIcon />}
                insuranceButtonTitle={window.sys_app_translate(
                  "Kasko Insurance",
                  lang
                )}
                secondaryButtonTitle={
                  window.sys_app_translate("Waiting Pricing") +
                  ": " +
                  (typeof user.agency_waitingpricing_kasko === "undefined"
                    ? "-"
                    : user.agency_waitingpricing_kasko)
                }
                showGlowingDot={user.agency_waitingpricing_kasko > 0}
                secondaryButtonTitle2={
                  window.sys_app_translate("Price is set") +
                  ": " +
                  (typeof user.agency_priceset_kasko === "undefined"
                    ? "-"
                    : user.agency_priceset_kasko)
                }
                showGlowingDot2={user.agency_priceset_kasko > 0}
                onClick={() => {
                  setCurrentRecord(KaskoInsuranceType);
                  history.push("/app/insurance-requests/create");
                }}
              />
              <InsuranceButtonElement
                insuranceButtonIcon={<TourismInsuranceButtonIcon />}
                insuranceButtonTitle={window.sys_app_translate(
                  "Tourism Insurance",
                  lang
                )}
                secondaryButtonTitle={
                  window.sys_app_translate("Waiting Pricing") +
                  ": " +
                  (typeof user.agency_waitingpricing_tourism === "undefined"
                    ? "-"
                    : user.agency_waitingpricing_tourism)
                }
                showGlowingDot={user.agency_waitingpricing_tourism > 0}
                secondaryButtonTitle2={
                  window.sys_app_translate("Price is set") +
                  ": " +
                  (typeof user.agency_priceset_tourism === "undefined"
                    ? "-"
                    : user.agency_priceset_tourism)
                }
                showGlowingDot2={user.agency_priceset_tourism > 0}
                onClick={() => {
                  setCurrentRecord(TourismInsuranceType);
                  history.push("/app/insurance-requests/create");
                }}
              />
            </div>
          </div>
        </div>
        <div
          className="row dashboard-section dashboard-elements-section"
          style={{
            marginTop: "1rem",
            height: this.state.dashboardThirdSectionHeight + "px",
            maxHeight: this.state.dashboardThirdSectionHeight + "px",
          }}
          ref={this.dashboardThirdSection}
        >
          <InsurancePricesElement
            lang={lang}
            setLoading={setLoading}
            handleAppError={handleAppError}
            isDiscountedPricesPermitted={
              permissions["dashboard"]["discounted-prices"]
            }
          />
          {/* <OrdersStatisticsElement /> */}
          <PricesCalculatorElement
            lang={lang}
            setLoading={setLoading}
            handleAppError={handleAppError}
            isDiscountedPricesPermitted={
              permissions["dashboard"]["discounted-prices"]
            }
          />
        </div>
      </>
    );
  }
  getSuperAdminDashboard() {
    const {
      agency_balance,
      lang,
      agency_credit,
      agency_percentage,
      agency_profit,
      is_debt_ok,
      permissions,
    } = this.props.user;
    const {
      insightAgenciesCount,
      insightBest5Agencies,
      insightInsurancesCount,
      insightInsurancesDiscountedTotal,
      insightInsurancesTotal,
      insightPendingInsuranceRequests,
      insightPendingBalanceRequests,
      insightTotalBalanceRequests,
      insightTotalDebt,
      insightUsersCount,
      insightProfit,
      periodicProfits,
      periodicProfitsSeries,
      periodicProfitsActiveChoice,
    } = this.state;
    const { history, setLoading, handleAppError, setCurrentRecord } =
      this.props;
    return (
      <>
        <div
          className="row dashboard-section super-admin-dashboard"
          ref={this.dashboardFirstSection}
        >
          <div className="offset-1 col-10 offset-md-0 col-md-12 px-0">
            <div className="row dashboard-section-inner-row ">
              <SuperAdminNumberItemElement
                icon={<SuperAdminDashboardItemProfitsIcon />}
                numberItemTitle={window.sys_app_translate("Profits", lang)}
                number={parseFloat(insightProfit).toFixed(2)}
                currencySymbol="TL"
                showThreeDotsClick={true}
                lang={lang}
                onDurationClick={async (insightDuration) => {
                  await this.setState({
                    insightDurationProfit: insightDuration,
                  });
                  await this.getSuperAdminInsights();
                }}
              />
              <SuperAdminNumberItemElement
                icon={<SuperAdminDashboardItemInsurancesCountIcon />}
                numberItemTitle={window.sys_app_translate("Insurances #", lang)}
                number={insightInsurancesCount.result}
                currencySymbol={window.sys_app_translate("Request", lang)}
                secondaryInformationText={
                  insightInsurancesCount.lastweek +
                  " " +
                  window.sys_app_translate("request Last week only", lang)
                }
                onDurationClick={async (insightDuration) => {
                  await this.setState({
                    insightDurationInsurancesCount: insightDuration,
                  });
                  await this.getSuperAdminInsights();
                }}
                lang={lang}
              />
              <SuperAdminNumberItemElement
                icon={<SuperAdminDashboardItemInsurancesTotalIcon />}
                numberItemTitle={window.sys_app_translate("Insurances ₺", lang)}
                number={insightInsurancesTotal.result}
                currencySymbol="TL"
                secondaryInformationText={
                  insightInsurancesTotal.lastweek +
                  " ₺" +
                  window.sys_app_translate("Last week only", lang)
                }
                onDurationClick={async (insightDuration) => {
                  await this.setState({
                    insightDurationInsurancesTotal: insightDuration,
                  });
                  await this.getSuperAdminInsights();
                }}
                lang={lang}
              />
              <SuperAdminNumberItemElement
                icon={<SuperAdminDashboardItemAgenciesCountIcon />}
                numberItemTitle={window.sys_app_translate("Agencies", lang)}
                number={insightAgenciesCount.result}
                currencySymbol={window.sys_app_translate("Agency", lang)}
                secondaryInformationText={
                  insightAgenciesCount.lastweek +
                  " " +
                  window.sys_app_translate("Agency in Last week only", lang)
                }
                onDurationClick={async (insightDuration) => {
                  await this.setState({
                    insightDurationAgenciesCount: insightDuration,
                  });
                  await this.getSuperAdminInsights();
                }}
                lang={lang}
              />
              <SuperAdminNumberItemElement
                icon={<SuperAdminDashboardItemDebtIcon />}
                numberItemTitle={window.sys_app_translate("Debt", lang)}
                number={insightTotalDebt}
                currencySymbol="TL"
                showThreeDotsClick={false}
                lang={lang}
              />
              <SuperAdminNumberItemElement
                icon={<SuperAdminDashboardItemUsersIcon />}
                numberItemTitle={window.sys_app_translate("Users", lang)}
                number={insightUsersCount.result}
                currencySymbol={window.sys_app_translate("User", lang)}
                secondaryInformationText={
                  insightUsersCount.lastweek +
                  " " +
                  window.sys_app_translate("users added Last week", lang)
                }
                onDurationClick={async (insightDuration) => {
                  await this.setState({
                    insightDurationUsersCount: insightDuration,
                  });
                  await this.getSuperAdminInsights();
                }}
                lang={lang}
                hideOnOtherThanMobile={true}
              />
            </div>
            <div className="row dashboard-section-inner-row top-margin-not-mobile">
              <SuperAdminNumberItemElement
                icon={<SuperAdminDashboardItemTotalPaymentsIcon />}
                numberItemTitle={window.sys_app_translate(
                  "Total Payments",
                  lang
                )}
                number={insightTotalBalanceRequests.result}
                currencySymbol="TL"
                secondaryInformationText={
                  insightTotalBalanceRequests.lastweek +
                  " ₺" +
                  window.sys_app_translate("Last week only", lang)
                }
                onDurationClick={async (insightDuration) => {
                  await this.setState({
                    insightDurationTotalBalanceRequests: insightDuration,
                  });
                  await this.getSuperAdminInsights();
                }}
                lang={lang}
              />
              <SuperAdminNumberItemElement
                icon={<SuperAdminDashboardItemTotalIncomeIcon />}
                numberItemTitle={window.sys_app_translate("Total Income", lang)}
                number={insightInsurancesDiscountedTotal.result}
                currencySymbol="TL"
                secondaryInformationText={
                  insightInsurancesDiscountedTotal.lastweek +
                  " ₺" +
                  window.sys_app_translate("Last week only", lang)
                }
                onDurationClick={async (insightDuration) => {
                  await this.setState({
                    insightDurationInsurancesDiscountedTotal: insightDuration,
                  });
                  await this.getSuperAdminInsights();
                }}
                lang={lang}
              />
              <SuperAdminNumberItemElement
                icon={<SuperAdminDashboardItemBalanceRequestsIcon />}
                numberItemTitle={window.sys_app_translate(
                  "Balance Requests",
                  lang
                )}
                number={insightPendingBalanceRequests}
                currencySymbol={window.sys_app_translate("Request", lang)}
                showThreeDotsClick={false}
                lang={lang}
              />
              <SuperAdminNumberItemElement
                icon={<SuperAdminDashboardItemPendingRequestsIcon />}
                numberItemTitle={window.sys_app_translate(
                  "Pending Requests",
                  lang
                )}
                number={insightPendingInsuranceRequests}
                currencySymbol={window.sys_app_translate("Request", lang)}
                showThreeDotsClick={false}
                lang={lang}
              />
              <SuperAdminNumberItemElement
                icon={<SuperAdminDashboardItemUsersIcon />}
                numberItemTitle={window.sys_app_translate("Users", lang)}
                number={insightUsersCount.result}
                currencySymbol={window.sys_app_translate("User", lang)}
                secondaryInformationText={
                  insightUsersCount.lastweek +
                  " " +
                  window.sys_app_translate("users added Last week", lang)
                }
                onDurationClick={async (insightDuration) => {
                  await this.setState({
                    insightDurationUsersCount: insightDuration,
                  });
                  await this.getSuperAdminInsights();
                }}
                lang={lang}
                hideOnMobile={true}
              />
            </div>
            <div className="row dashboard-section-inner-row top-margin-not-mobile">
              <SuperAdminNumberItemElement
                icon={
                  <Icon
                    icon="pepicons-pop:division-circle"
                    width="48.556"
                    height="48.501"
                    color={AppConfig.themeColors.primary}
                  />
                }
                numberItemTitle={window.sys_app_translate("Avg Ratios", lang)}
                numberTwoItemTitle={window.sys_app_translate(
                  "Avg Prices",
                  lang
                )}
                togglePopup={() => {
                  this.setState({ showAvgRatiosPopup: true });
                }}
                showPopUpOnClick={true}
                number={this.state.avgRatios}
                numberTwo={this.state.avgPrices}
                currencySymbol={window.sys_app_translate("%", lang)}
                currencyTwoSymbol={window.sys_app_translate("TL", lang)}
                isPercentage={false}
                isTwoPercentage={false}
                secondaryInformationText={
                  insightUsersCount.lastweek +
                  " " +
                  window.sys_app_translate("users added Last week", lang)
                }
                lang={lang}
                hideOnMobile={false}
              />
            </div>
            <div
              className="row dashboard-section-inner-row row-top-margin"
              style={{
                paddingLeft: "12px",
                paddingRight: "12px",
              }}
            >
              <div
                className="col-12 col-md-7 col-lg-8 profits-chart-container"
                style={{
                  position: "relative",
                  backgroundColor: "white",
                  borderRadius: "15px",
                }}
              >
                <ProfitsChartElement
                  data={periodicProfits}
                  series={periodicProfitsSeries}
                  lang={lang}
                  activeChoice={periodicProfitsActiveChoice}
                  setActiveChoice={async (choice) => {
                    await this.setState({
                      periodicProfitsActiveChoice: choice,
                    });
                    this.getPeriodicProfitsData(choice);
                  }}
                  selectDataType={async (type) => {
                    await this.setState({
                      periodicDataType: type,
                    });
                    await this.getPeriodicProfitsData(
                      this.state.periodicProfitsActiveChoice
                    );
                  }}
                />
              </div>
              <div className="col-12 col-md-5 col-lg-4 best-agencies-column">
                <div
                  className="container best-agencies-top-container"
                  style={{
                    backgroundColor: "white",
                    borderRadius: "15px",
                    paddingBottom: "1rem",
                    paddingRight: "1rem",
                    paddingLeft: "1rem",
                  }}
                >
                  <div
                    className="row"
                    style={{
                      paddingBottom: "1rem",
                      paddingTop: "1rem",
                    }}
                  >
                    <div
                      className="col-8 inter inter-semi-bold"
                      style={{ fontSize: "1rem", paddingLeft: "2rem" }}
                    >
                      {window.sys_app_translate("Best Agencies", lang)}
                    </div>
                    {/* <div
                      className="col-4 d-flex justify-content-end inter inter-semi-bold"
                      style={{
                        color: "#199B8B",
                        cursor: "pointer",
                        paddingRight: "2rem",
                      }}
                    >
                      {window.sys_app_translate("View All", lang)}
                    </div> */}
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div
                        className="container best-agencies-container"
                        style={{ maxHeight: "350px", overflowY: "auto" }}
                      >
                        {insightBest5Agencies.map((item, index) => (
                          <div
                            className="row"
                            style={{
                              marginTop: "1rem",
                            }}
                            key={"agen" + index}
                          >
                            <div className="col-9 px-0">
                              <div className="container">
                                <div className="row px-0">
                                  <div className="col-4 d-flex justify-content-center">
                                    {item.logo && (
                                      <img
                                        src={AppConfig.storagePath + item.logo}
                                        style={{
                                          width: "3rem",
                                          height: "3rem",
                                        }}
                                      />
                                    )}
                                  </div>
                                  <div className="col-8">
                                    <div className="container">
                                      <div className="row px-0">
                                        <div
                                          className="col-12 inter inter-semi-bold"
                                          style={{ fontSize: "1rem" }}
                                        >
                                          {item.name}
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div
                                          className="col-12 inter inter-semi-bold"
                                          style={{ fontSize: "0.8rem" }}
                                        >
                                          {window.sys_app_translate(
                                            "Insurance Income:"
                                          )}
                                          {item.count}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-3 px-0 text-center inter">
                              {item.totalprice}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  async getSuperAdminInsights() {
    const { handleAppError, setLoading } = this.props;
    try {
      setLoading(true);
      const {
        insightDurationInsurancesCount,
        insightDurationInsurancesTotal,
        insightDurationInsurancesDiscountedTotal,
        insightDurationAgenciesCount,
        insightDurationTotalBalanceRequests,
        insightDurationUsersCount,
        insightDurationProfit,
      } = this.state;
      const response = await axios.get("/users/super-admin-insights", {
        params: {
          insurances_count: insightDurationInsurancesCount,
          insurances_total: insightDurationInsurancesTotal,
          insurances_discounted_total: insightDurationInsurancesDiscountedTotal,
          agencies_count: insightDurationAgenciesCount,
          total_balance_requests: insightDurationTotalBalanceRequests,
          users_count: insightDurationUsersCount,
          profits: insightDurationProfit,
        },
      });
      const result = response.data.data;
      await this.setState({
        insightInsurancesCount: result.insurances_count,
        insightInsurancesTotal: result.insurances_total,
        insightInsurancesDiscountedTotal: result.insurances_discounted_total,
        insightAgenciesCount: result.agencies_count,
        insightTotalDebt: result.total_debt,
        insightTotalBalanceRequests: result.total_balance_requests,
        insightPendingBalanceRequests: result.pending_balance_requests,
        insightPendingInsuranceRequests: result.pending_insurance_requests,
        insightUsersCount: result.users_count,
        insightBest5Agencies: result.best_5_agencies,
        insightProfit: result.profits.result,
      });
      setLoading(false);
    } catch (error) {
      handleAppError(error);
    }
  }
  async getPeriodicProfitsData(insightDuration = InsightDurationDaily) {
    const { handleAppError, setLoading } = this.props;
    const { periodicDataType } = this.state;
    try {
      console.log("getting periodic profits data ...");
      setLoading(true);
      const response = await axios.get("users/periodic-profits", {
        params: {
          datatype: periodicDataType,
          insightduration: insightDuration,
        },
      });
      const data = response.data.data;
      await this.setState({
        periodicProfits: null,
        periodicProfitsSeries: null,
      });
      await this.setState({
        periodicProfits: data[0],
        periodicProfitsSeries: data[1],
      });
      setLoading(false);
    } catch (error) {
      handleAppError(error);
    }
  }
  async fetchAvgRatio(params) {
    try {
      const res = await axios.get(
        "/insurance-requests/get-average-agencies-ratios-approved-insurances",
        {
          params,
        }
      );

      return res;
    } catch (error) {
      handleAppError(error);
      setLoading(true);
    } finally {
      setLoading(false);
    }
  }
  render() {
    const { is_super_admin, can_see_super_admin_dashboard, lang } =
      this.props.user;
    const { insightInsurancesCount } = this.state;
    const canSeeSuperAdminDashboard =
      is_super_admin || can_see_super_admin_dashboard;
    // const agencyCredit = parseFloat(agency_credit).toFixed(2);
    // const agencyProfit = parseFloat(agency_profit).toFixed(2);
    return (
      <React.Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{window.sys_app_translate("Home", lang)}</title>
        </Helmet>
        {canSeeSuperAdminDashboard
          ? insightInsurancesCount
            ? this.getSuperAdminDashboard()
            : null
          : this.getDashbord()}
        {/* {is_super_admin
          ? insightInsurancesCount
            ? this.getDashbord()
            : null
          : this.getDashbord()} */}
        <ITQModalV2
          isOpen={this.state.showAvgRatiosPopup}
          isCenterd={true}
          cancelButtonClicked={() => {
            this.setState({ showAvgRatiosPopup: false });
          }}
          size="md"
          title={window.sys_app_translate("Average Ratios", lang)}
          bodyContent={
            <InsuranceRatioForm
              getAverageRatio={this.fetchAvgRatio}
              onFormSubmitCallback={(data) => {
                this.setState({
                  showAvgRatiosPopup: false,
                  avgRatios: data.avg_ratio,
                  avgPrices: data.avg_price,
                });
              }}
              onFormCancel={() => {
                this.setState({ showAvgRatiosPopup: false });
              }}
              props={this.props}
            />
          }
        />
      </React.Fragment>
    );
  }
}

// map state to props
const mapStateToProps = ({ authUser, appReducer }) => {
  const { user } = authUser;
  const { formErrors, currentRecord } = appReducer;
  return { user, formErrors, currentRecord };
};
export default connect(mapStateToProps, {
  setLoading,
  showMessage,
  handleAppError,
  clearFormErrors,
  setCurrentRecord,
})(Home);
